var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-card',{staticClass:"box-card"},_vm._l((4),function(o){return _c('div',{key:o,staticClass:"text item"},[_vm._v("\n            "+_vm._s('列表内容 ' + o)+"\n        ")])}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }